export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_green.d269cae2.jpg";